import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import LegalLayout from 'components/legal/LegalLayout';
import { mapCookiePolicyToSections } from 'utils/legal/sections';

const CookieSettings = () => {
  const { t, language } = useTranslation();
  
  // Re-compute sections when language changes
  const sections = useMemo(() => mapCookiePolicyToSections(t), [language]);
  const title = t('title', 'cookies') || 'Cookie Policy';
  const lastUpdated = t('lastUpdated', 'cookies') || '';

  const termlyLink = t('termlyLink', 'cookies');

  return (
    <div>
      <LegalLayout title={title} lastUpdated={lastUpdated} sections={sections} />
      
      {/* Termly Cookie Consent Manager Link – theme from config */}
      {termlyLink && (
        <div
          className="cookie-settings-termly"
          style={{
            marginTop: 'var(--spacing-3xl)',
            padding: 'var(--spacing-xl)',
            borderTop: '1px solid var(--color-border)',
            backgroundColor: 'var(--color-bg-secondary)',
            borderRadius: 'var(--radius-md)',
            maxWidth: '800px',
            margin: 'var(--spacing-3xl) auto 0',
            textAlign: 'center'
          }}
        >
          <h2 style={{ marginBottom: 'var(--spacing-md)', fontSize: 'var(--text-xl)' }}>
            {termlyLink.heading || 'Cookie Consent Manager'}
          </h2>
          <p style={{ marginBottom: 'var(--spacing-xl)', color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)' }}>
            {termlyLink.description || 'To manage your cookie preferences and view detailed information about the cookies we use, please visit our Cookie Consent Manager:'}
          </p>
          <a
            href={termlyLink.linkUrl || 'https://app.termly.io/policy-viewer/policy.html?policyUUID=ea77f126-a5bb-43d5-808c-6a54c00bdef1'}
            target="_blank"
            rel="noopener noreferrer"
            className="cookie-settings-termly-link"
            style={{
              display: 'inline-block',
              padding: 'var(--spacing-sm) var(--spacing-xl)',
              backgroundColor: 'var(--color-primary)',
              color: 'var(--color-text-inverse)',
              textDecoration: 'none',
              borderRadius: 'var(--radius-sm)',
              fontWeight: 'var(--font-weight-medium)',
              transition: 'background-color var(--transition-normal)',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'var(--color-primary-hover)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'var(--color-primary)';
            }}
          >
            {termlyLink.linkText || 'Open Cookie Consent Manager'}
          </a>
        </div>
      )}
    </div>
  );
};

export default CookieSettings;
